module.exports = __webpack_public_path__ + "static/goodwill-logo-facc37c5589b7d01fba0d4c1e36db6ab.svg";